<!-- No Documents Message -->
<div *ngIf="documents?.length === 0" class="alert alert-info text-center">
  No documents found.
</div>

<!-- Documents Table -->
<div class="table-responsive" *ngIf="documents?.length > 0">
  <table class="table table-striped table-bordered">
    <thead>
      <tr>
        <th style="width: 60%;">Document Name</th>
        <th style="width: 15%;">Type</th>
        <th style="width: 20%;">Upload Date</th>
        <th style="width: 5%;">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let doc of documents">
        <td>{{ doc.fileName }}</td>
        <td>{{ doc.documentType }}</td>
        <td>{{ doc.uploadDate | date: 'MM-dd-yyyy' }}</td>
        <td>
          <a href="javascript:void(0)" 
             (click)="getCandidateDocument(doc.fileGuid, doc.fileName, 'PDF')" 
             title="Download Document">
            View
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>